import createPdf, {
  createDocument,
  createPages,
  createTableHeader,
} from '../createPdf';

import { get, pick } from 'lodash';

const SPACE = ' ';

const yearOfBirth = (dateOfBirth) => {
  if (dateOfBirth == SPACE)
    return SPACE;

  return dateOfBirth.split('.')[2];
}

const createAthleteRow = (row, index) => [
  { text: index + 1, alignment: 'right' },
  //{ text: get(row, 'sex', SPACE), alignment: 'center' },
  { text: get(row, 'name', SPACE) },
  { text: yearOfBirth(get(row, 'dateOfBirth', SPACE)), alignment: 'right' },
  { text: get(row, 'teams', [SPACE]).join(', ') },
  { text: get(row, 'categories', [SPACE]).join(', '), alignment: 'center' },
  { text: get(row, 'entryTotal', SPACE), alignment: 'right' },
];

const createEntryListPage = entryList => {
  const columns = [
    '',
    // '',
    'NAME',
    'D.O.B.',
    'TEAM',
    'CATEGORY',
    'ENTRY',
  ];
  const widths = [15, /*15,*/ '*', 65, 80, 65, 40];
  return [
    {
      text: `ENTRY LIST ${get(entryList, 'title', '')}`,
      style: 'header',
    },
    {
      table: {
        headerRows: 1,
        widths,
        body: [
          createTableHeader(columns),
          ...entryList.athletes.map(createAthleteRow),
        ],
      },
    },
  ];
};

const createEntryListsPdf = (entryLists, meta) => {
  const [event] = meta.orm.events;
  const content = createPages(
    entryLists,
    createEntryListPage,
    pick(event, 'title', 'location', 'duration'),
  );

  const documentDefinition = createDocument('Entry Lists', content);

  return createPdf(documentDefinition);
};

export default createEntryListsPdf;



// WEBPACK FOOTER //
// ./src/pages/Home/entryLists/createEntryListsPdf.js